import React from "react";
import { Link } from 'react-router-dom';

import defaultAvatar from '../../images/default-avatar.jpg'

export default ({user}) => (
    <Link className="user-greeting"  to="/account">
        {
            user.avatar
            ? <div className="avatar" style={{backgroundImage: `url(${window.siteUrl}${user.avatar})`}}></div>
            : <div className="avatar" style={{backgroundImage: `url(${defaultAvatar})`}}></div>
        }
        <div className="user-greeting-text">
            Привет, <span className="text_pink">{user.first_name}</span>
        </div>
    </Link>
)


// WEBPACK FOOTER //
// ./src/components/Commons/Greetings.js